import { DD } from "@/constants/testIds";

// Lookup tables replace two nested ternaries per step row.
const STEP_COLOR_CLASS = {
    running: "text-ciff-inkSoft",
    error: "text-rose-700",
    done: "text-ciff-ink",
};
const STEP_ICON = { running: "…", error: "✗", done: "✓" };

export default function ProgressLog({ steps, phase, status, errorMsg }) {
    const completedCount = steps.filter((s) => s.status === "done" || s.status === "error").length;
    const total = steps.length;
    return (
        <div
            data-testid={DD.progressLog}
            className="px-6 pb-6 pt-2 border-t border-border"
        >
            <div className="text-[10px] uppercase tracking-[0.2em] text-ciff-inkSoft font-mono mb-2">
                Sidebar progress · {completedCount}/{total || "—"} tasks
                {phase === "synthesis" ? " · synthesising" : ""}
            </div>
            <div className="space-y-1 max-h-[40vh] overflow-y-auto pr-1">
                {steps.map((s, i) => {
                    const st = s.status || "done";
                    return (
                        <div
                            key={`${s.label}-${i}`}
                            data-testid={DD.progressStep}
                            className="flex items-start gap-2 font-mono text-[11px] leading-tight"
                        >
                            <span className={STEP_COLOR_CLASS[st] || STEP_COLOR_CLASS.done}>
                                {STEP_ICON[st] || STEP_ICON.done}
                            </span>
                            <span className="text-ciff-ink break-words">{s.label}</span>
                        </div>
                    );
                })}
            </div>
            {status === "error" && errorMsg && (
                <div className="mt-3 text-[11px] font-mono text-rose-700 bg-rose-50 border border-rose-300 rounded-sm px-2 py-1.5 break-words">
                    ✗ {errorMsg}
                </div>
            )}
        </div>
    );
}
